export default "__VITE_ASSET__8opHm3UQ__"